<template>
    <div class="card mt-3">
        <div class="card-body">
            <h5 class="card-title">Logger Details</h5>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Logger ID/MAC Address</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="loggerData.loggerId" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Database Size (in KB)</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': databaseSizeError }"
                        v-model="loggerData.databaseSize"
                        @change="validateDatabaseSize" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 10240 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">MODBUS RTU Timeout (in milliseconds)</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': rtuTimeoutError }"
                        v-model="loggerData.rtuTimeout"
                        @change="validateRtuTimeout" />
                    <div class="invalid-feedback">Numbers only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">MODBUS TCP Timeout (in milliseconds)</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': tcpTimeoutError }"
                        v-model="loggerData.tcpTimeout"
                        @change="validateTcpTimeout" />
                    <div class="invalid-feedback">Numbers only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Modbus write over TCP?</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="loggerData.tcpStatus">
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                    </select>
                </div>
            </div>
            <div class="form-group row" v-if="loggerData.tcpStatus === '1'">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">TCP Port</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': tcpPortError }"
                        v-model="loggerData.tcpPort"
                        @change="validateTcpPort" />
                    <div class="invalid-feedback">Numbers only</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            rtuTimeoutError: false,
            tcpTimeoutError: false,
            tcpPortError: false,
            databaseSizeError: false
        }
    },
    props: ['loggerData'],
    methods: {
        validateRtuTimeout() {
            if(/^\d+$/.test(this.loggerData.rtuTimeout)) {
                this.rtuTimeoutError = false
            } else {
                this.rtuTimeoutError = true
            }
        },
        validateTcpTimeout() {
            if(/^\d+$/.test(this.loggerData.tcpTimeout)) {
                this.tcpTimeoutError = false
            } else {
                this.tcpTimeoutError = true
            }
        },
        validateTcpPort() {
            if(/^\d+$/.test(this.loggerData.tcpPort)) {
                this.tcpPortError = false
            } else {
                this.tcpPortError = true
            }
        },
        validateDatabaseSize() {
            if((/^[0-9]+$/.test(this.loggerData.databaseSize) && (parseInt(this.loggerData.databaseSize) > 0 && parseInt(this.loggerData.databaseSize) < 10241)) || this.loggerData.databaseSize === 'NULL') {
                this.databaseSizeError = false
            } else {
                this.databaseSizeError = true
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/logger-details/LoggerDetails.vue